import { Navigate, useLocation, useMatch } from 'react-router';

import { useIsTrainingModeEnabled } from '../../hooks/useIsTrainingModeEnabled.ts';
import { REFERRED_BY_PARAM_KEY } from '../../modules/onboarding/consts.ts';
import { selectIsOnboardingComplete } from '../../redux/features/selectors/accountSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { useToolkitControllerGlobal } from '../hooks/useToolkitControllerGlobal.ts';

const hasSearchParams = (params: URLSearchParams): boolean => Array.from(params.keys()).length > 0;

export const SubscriptionGuard = ({ children }: React.PropsWithChildren) => {
  const { subscription } = useToolkitControllerGlobal();
  const isOnboardingComplete = useAppSelector(selectIsOnboardingComplete);
  const isInOnboardingWizard = useMatch('/onboarding'); // HACK: Ensure we don't get kicked to /subscribe if we're subscribed but still in the onboarding wizard
  const { search } = useLocation();

  const { isTrainingModeEnabled } = useIsTrainingModeEnabled();
  if (isTrainingModeEnabled) return children;

  if (isOnboardingComplete && !isInOnboardingWizard && !subscription.hasActiveSubscription) {
    return <Navigate to="/subscribe" />;
  }

  if (!isOnboardingComplete && !isInOnboardingWizard) {
    const passedSearchParams = new URLSearchParams(search);
    const referredBy = passedSearchParams.get(REFERRED_BY_PARAM_KEY);

    const cleanedSearchParams = new URLSearchParams();
    if (referredBy) cleanedSearchParams.set(REFERRED_BY_PARAM_KEY, referredBy);

    const query = hasSearchParams(cleanedSearchParams) ? `?${cleanedSearchParams.toString()}` : '';

    return <Navigate to={`/onboarding${query}`} />;
  }

  return children;
};
